import { Select } from "@mantine/core";
import { useState } from "react";

import { useForm } from "@mantine/form";

export default function UserType({ setActivePage, onCardClick, user }) {
  const [dropDownData, setDropDownData] = useState([]);
  const form = useForm({
    initialValues: {
      user: null,
    },
  });

  const handleUserSelect = (value) => {
    form.setFieldValue("user", value);
    setActivePage(1);
    if (onCardClick) {
      onCardClick(value);
    }
  };

  return (
    <Select
      placeholder="Filter By User"
      data={[
        { value: "driver", label: "Driver" },
        { value: "retailer", label: "Retailer" },
      ]}
      value={form.values.user || user}
      onChange={(value) => {
        handleUserSelect(value);
      }}
      style={{ marginBottom: "20px" }}
      onClear={() => handleUserSelect(null)}
      clearable
      searchable
      withinPortal
    />
  );
}
